import(/* webpackMode: "eager" */ "/work/web/app/market/src/app/auth/callback/page.tsx");
